import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "./AuthContext";
import { useLang } from "../i18n/LanguageContext";
import { LanguageSwitcher } from "../components/LanguageSwitcher";

export default function AdminLogin() {
  const { login } = useAuth();
  const { t } = useLang();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(username, password);
      navigate("/admin/dashboard");
    } catch (err) {
      const d = err.response?.data?.detail;
      setError(typeof d === "string" ? d : "Klaida / Error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-charcoal flex items-center justify-center p-6" data-testid="admin-login-page">
      <div className="absolute top-6 right-6"><LanguageSwitcher /></div>
      <div className="w-full max-w-md">
        <div className="text-center mb-10">
          <span className="font-serif text-3xl text-cream">Sakurų namai</span>
          <div className="flex items-center justify-center gap-2 mt-4">
            <Lock size={16} className="text-gold" />
            <p className="text-xs uppercase tracking-[0.25em] text-gold/70">{t("admin.loginTitle")}</p>
          </div>
          <p className="text-cream/40 text-sm mt-2">{t("admin.loginSub")}</p>
        </div>

        <form onSubmit={submit} className="space-y-5 bg-charcoal-light border border-gold/20 rounded-lg p-8">
          <div>
            <label className="block text-[11px] uppercase tracking-widest text-gold/70 mb-2">{t("admin.username")}</label>
            <input
              data-testid="admin-username"
              className="w-full bg-transparent border border-cream/20 focus:border-gold text-cream px-4 py-3 outline-none transition-colors"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              autoComplete="username"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-widest text-gold/70 mb-2">{t("admin.password")}</label>
            <input
              data-testid="admin-password"
              type="password"
              className="w-full bg-transparent border border-cream/20 focus:border-gold text-cream px-4 py-3 outline-none transition-colors"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="current-password"
            />
          </div>
          {error && <p className="text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
          <button
            type="submit"
            disabled={loading}
            data-testid="admin-login-submit"
            className="w-full bg-gold text-charcoal text-xs uppercase tracking-widest py-4 font-medium hover:bg-gold-muted transition-colors disabled:opacity-50"
          >
            {loading ? t("admin.loggingIn") : t("admin.login")}
          </button>
        </form>
      </div>
    </div>
  );
}
